import styled from 'styled-components';

import defaultShield from '#src/assets/club/shield_none.webp';
import { ResponsiveImg } from '#src/atoms/ui/ResponsiveImg/index.tsx';
import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  shieldUrl?: string | null;
  clubName?: string | null;
  size?: Unit;
};

const Root = styled(ResponsiveImg)`
  object-fit: contain;
  aspect-ratio: 1/1;
`;

export const ClubShield = ({ shieldUrl, clubName, size = 4 }: Props) => {
  return (
    <Root
      style={{ height: unitMapping[size] }}
      cropWidth={40}
      src={shieldUrl || defaultShield}
      alt={clubName || ''}
      onError={e => {
        e.currentTarget.src = defaultShield;
      }}
    />
  );
};
